import { render, staticRenderFns } from "./pages12.vue?vue&type=template&id=2dd081e2&scoped=true&"
import script from "./pages12.vue?vue&type=script&lang=js&"
export * from "./pages12.vue?vue&type=script&lang=js&"
import style0 from "./pages12.vue?vue&type=style&index=0&id=2dd081e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dd081e2",
  null
  
)

export default component.exports